<template>
  <div id="izl_rmenu" class="izl-rmenu">
    <div class="btn btn-wx" @mouseenter="secondShow(1)" @mouseleave="secondHide(1)">
      <img class="pic" src="../assets/imgs/weixin.jpg" :style="{display: picDisplay}" />
    </div>
    <div class="btn btn-phone" @mouseenter="secondShow(2)" @mouseleave="secondHide(2)">
      <div class="phone" :style="{display: phoneDisplay}">400-707-0678</div>
    </div>
    <div class="btn btn-xs" @mouseenter="secondShow(3)" @mouseleave="secondHide(3)">
      <div class="xs" :style="{display: xsDisplay}">010-85112336</div>
    </div>
    <div class="btn btn-mail" @mouseenter="secondShow(4)" @mouseleave="secondHide(4)">
      <div class="mail" :style="{display: mailDisplay}">sales@drcnet.com.cn</div>
    </div>
    <div v-if="isShow" class="btn btn-top" @click="backTop"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      picDisplay: "none", //右侧联系方式
      phoneDisplay: "none",
      xsDisplay: "none",
      mailDisplay: "none",
      isShow: false //右侧联系方式中回到顶部
    };
  },
  methods: {
    //右侧联系方式-回到顶部是否显示
    scrollToTop() {
      if (document.documentElement.scrollTop > 100) {
        this.isShow = true;
      } else if (document.documentElement.scrollTop < 100) {
        this.isShow = false;
      }
    },
    //右侧联系方式-回到顶部
    backTop() {
      let timer = setInterval(() => {
        let top = document.documentElement.scrollTop;
        let speed = Math.ceil(top / 5);
        document.documentElement.scrollTop = top - speed;
        if (top === 0) {
          clearInterval(timer);
        }
      }, 20);
    },
    //右侧联系方式-鼠标移上显示对应的
    secondShow(num) {
      if (num === 1) {
        this.picDisplay = "block";
      } else if (num === 2) {
        this.phoneDisplay = "block";
      } else if (num === 3) {
        this.xsDisplay = "block";
      } else if (num === 4) {
        this.mailDisplay = "block";
      }
    },
    //右侧联系方式-鼠标移开隐藏对应的
    secondHide(num) {
      if (num === 1) {
        this.picDisplay = "none";
      } else if (num === 2) {
        this.phoneDisplay = "none";
      } else if (num === 3) {
        this.xsDisplay = "none";
      } else if (num === 4) {
        this.mailDisplay = "none";
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop); //右侧联系方式-回到顶部
  }
};
</script>
<style lang="less">
</style>